import React, { useState } from 'react';
import styled from 'styled-components';

const CouponContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 30px;
  color: #111827;
  text-align: center;
`;

const TabContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 30px;
`;

const Tab = styled.button`
  padding: 12px 24px;
  border: none;
  background: none;
  color: ${props => props.active ? '#3b82f6' : '#6b7280'};
  border-bottom: 2px solid ${props => props.active ? '#3b82f6' : 'transparent'};
  cursor: pointer;
  font-size: 16px;
  font-weight: ${props => props.active ? '600' : '400'};
`;

const CouponGrid = styled.div`
  display: grid;
  gap: 16px;
`;

const CouponCard = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
`;

const CouponTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
`;

const CouponDiscount = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 12px;
`;

const CouponCondition = styled.div`
  font-size: 14px;
  opacity: 0.9;
  margin-bottom: 8px;
`;

const CouponExpiry = styled.div`
  font-size: 12px;
  opacity: 0.8;
`;

const UseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 12px;
  
  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

export default function Coupon() {
  const [activeTab, setActiveTab] = useState('available');
  
  const availableCoupons = [
    {
      id: 1,
      title: '신규가입 축하 쿠폰',
      discount: '10% 할인',
      condition: '50,000원 이상 구매시',
      expiry: '2024.12.31까지'
    },
    {
      id: 2,
      title: '여름 특가 쿠폰',
      discount: '15,000원 할인',
      condition: '100,000원 이상 구매시',
      expiry: '2024.08.31까지'
    },
    {
      id: 3,
      title: '무료배송 쿠폰',
      discount: '배송비 무료',
      condition: '30,000원 이상 구매시',
      expiry: '2024.09.15까지'
    }
  ];
  
  const usedCoupons = [
    {
      id: 4,
      title: '회원등급 혜택 쿠폰',
      discount: '5,000원 할인',
      condition: '30,000원 이상 구매시',
      usedDate: '2024.07.15 사용완료'
    }
  ];

  return (
    <CouponContainer>
      <Title>쿠폰함</Title>
      
      <TabContainer>
        <Tab active={activeTab === 'available'} onClick={() => setActiveTab('available')}>
          사용 가능한 쿠폰 ({availableCoupons.length})
        </Tab>
        <Tab active={activeTab === 'used'} onClick={() => setActiveTab('used')}>
          사용한 쿠폰 ({usedCoupons.length})
        </Tab>
      </TabContainer>
      
      <CouponGrid>
        {activeTab === 'available' && availableCoupons.map(coupon => (
          <CouponCard key={coupon.id}>
            <UseButton>사용하기</UseButton>
            <CouponTitle>{coupon.title}</CouponTitle>
            <CouponDiscount>{coupon.discount}</CouponDiscount>
            <CouponCondition>{coupon.condition}</CouponCondition>
            <CouponExpiry>{coupon.expiry}</CouponExpiry>
          </CouponCard>
        ))}
        
        {activeTab === 'used' && usedCoupons.map(coupon => (
          <CouponCard key={coupon.id} style={{ opacity: 0.6, filter: 'grayscale(50%)' }}>
            <CouponTitle>{coupon.title}</CouponTitle>
            <CouponDiscount>{coupon.discount}</CouponDiscount>
            <CouponCondition>{coupon.condition}</CouponCondition>
            <CouponExpiry>{coupon.usedDate}</CouponExpiry>
          </CouponCard>
        ))}
      </CouponGrid>
    </CouponContainer>
  );
}